import Vue from "vue";
import Vuex from "vuex";
import ambulanceSearch from "./search/ambulance";
import user from "./user.js";
import opd from "./opd/index";
// import newBorn from "./opd/newBorn";
import registration from "./registration";
import general from "./general";
import appointment from "./appointment.js";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ambulanceSearch,
    user,
    opd,
    registration,
    general,
    appointment,
    // newBorn
  }
});
